import React, { Component } from 'react';
import ReactMultiToggle from 'react-multi-toggle';
import './dpit-switch.scss';
import classNames from 'classnames';


export default class Switch extends Component {
	constructor(props) {
		super(props);
	}

	getToggleClass(bemRoot, optionIdx, extraClass) {
		return classNames({
			[bemRoot + '__toggle']: true,
			[bemRoot + '__toggle--on']: optionIdx === 0,
			[bemRoot + '__toggle--off']: optionIdx === 1,
			[extraClass]: extraClass

		});
	}

	render() {
		const bemRoot = this.props.classBEMRoot ?? 'dpit-switch';

		const className = classNames({
			[bemRoot]: bemRoot,
			[this.props.className]: this.props.className,

		});
		const options = this.props.options
			? this.props.options.map((option, idx) => {
				return {
					...option,
					optionClass: this.getToggleClass(bemRoot, idx, option.optionClass)
				};
			})
			: [];

		const reactMultiToggleProps = {
			...this.props,
			className,
			options
		};

		return <ReactMultiToggle
			{...reactMultiToggleProps}
		/>;
	}
}